import { defineNamespace } from '../core';
import { en } from './en';
import { fr } from './fr';

export const errors = defineNamespace('errors', fr, en);
